import { Card, CardContent, Stack } from '@mui/material'
import { IconButton, ItemImageAreaSkeleton, SkeletonText } from 'utoniq-ui'

export const ConsoleMissionBoxSkeleton = () => (
  <Card>
    <CardContent sx={{ p: 5 }}>
      <Stack
        sx={{ pb: 4 }}
        direction="row"
        justifyContent="space-between"
        spacing={4}
      >
        <SkeletonText variant="medium" width="100%" />
        <Stack direction="row" spacing={3}>
          <IconButton.Pencil size="small" bgcolor="grey.100" color="grey.700" />
          <IconButton.Trash size="small" bgcolor="grey.100" color="grey.700" />
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={4}>
        <Stack spacing={2} sx={{ minWidth: 231 }}>
          <SkeletonText variant="small" width="100%" />
          <SkeletonText variant="small" width="100%" />
          <SkeletonText variant="small" width="75%" />
        </Stack>
        <Stack sx={{ minWidth: 48 }}>
          <ItemImageAreaSkeleton size="x-small" />
        </Stack>
      </Stack>
    </CardContent>
  </Card>
)
